"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// COLORS
const style = "normal";
const brand = "#9ab534";
const headerBackgroundColor = "#FFFFFF";
const headerTextColor = brand;
const mainInfoPortrait = brand;
const mainInfoLandscape = brand;
const appAccentColor = brand;
const colorAppBar = "#FFFFFF"; // dark green
const colorOnAppBar = "#9ab534"; // white
const colorPrimary = "#9ab534";
const colorPrimaryDarker = "#738827";
const colorPrimaryLighter = "#ecf3d4";
const colorOnPrimary = "#FFFFFF";
const colorSecondary = "#9ab534";
const colorOnSecondary = "#FFFFFF";
const colorTiles = ["#9ab534", "#9ab534", "#9ab534"];
exports.default = {
    brand,
    mainInfoPortrait,
    mainInfoLandscape,
    headerBackgroundColor,
    headerTextColor,
    style,
    appAccentColor,
    colorAppBar,
    colorOnAppBar,
    colorPrimary,
    colorPrimaryDarker,
    colorPrimaryLighter,
    colorOnPrimary,
    colorSecondary,
    colorOnSecondary,
    colorTiles,
};
